// extracted by mini-css-extract-plugin
export default {"root":"_3WHa1yVQ","secondary":"BTwvWBOJ","original":"a0n9wdBN","standard":"vHHx_7xo","commerce":"_1dChRjTX","small":"_183cBLMI","large":"_2OpsyM96","fullWidth":"_N28mfeX"};